module.exports = __webpack_public_path__ + "img/table-title-buildings.43bb657f.svg";